import homeAnim from "./home";
import projectAnim from "./project";
import projectsAnim from "./projects";
import agenceAnim from "./agence";
import contactAnim from "./contact";

let homepage = document.querySelector("#home");
if (homepage !== null) {
  homeAnim.init();
}

let projectPage = document.querySelector("#project");
if (projectPage !== null) {
  projectAnim.init();
}

let projectsPage = document.querySelector("#projects");
if (projectsPage !== null) {
  projectsAnim.init();
}

let agencePage = document.querySelector("#agence");
if (agencePage !== null) {
  agenceAnim.init();
}

let contactPage = document.querySelector("#contact");
if (contactPage !== null) {
  contactAnim.init();
}
